(function (widgets) {
  var FreeText = widgets.Widget.extend(
    {
      constructor: function FreeTextConstructor(object) {
        this._object = object || {};

        var $emptyFreeText = $('#' + this._object.elemId + '.free-text').filter(
          function () {
            return (
              $(this).children().length === 0 && $.trim($(this).text()) === ''
            );
          }
        );
        if ($emptyFreeText.length > 0) {
          this.$el = $($emptyFreeText.get(0));
        } else {
          this.$el = $('#' + this._object.elemId + '.free-text').first();
        }

        if (!this.$el || !this.$el.length) {
          console.warn('FreeText: container not found for', this._object);
          this.$el = $('<div></div>');
        }

        try {
          this._resetClasses();
          this._appendClass(this._object.view || 'free-text');
        } catch (ignore) {}
      },

      render: function render() {
        var content = this._object.text || '';
        this.$el.empty();

        try {
          var tmp = document.createElement('div');
          tmp.innerHTML = content;

          while (tmp.firstChild) {
            var node = tmp.firstChild;
            tmp.removeChild(node);

            if (node.tagName && node.tagName.toLowerCase() === 'script') {
              var newScript = document.createElement('script');

              if (node.attributes) {
                for (var a = 0; a < node.attributes.length; a++) {
                  var attr = node.attributes[a];
                  try {
                    newScript.setAttribute(attr.name, attr.value);
                  } catch (e) {}
                }
              }

              if (node.src) {
                newScript.src = node.src;
                newScript.onerror = function (e) {
                  var err =
                    e || 'Failed to load script: ' + (node.src || 'unknown');
                  throw new Error(err, {
                    cause: 'customQSLError',
                    page_name:
                      typeof page_state !== 'undefined'
                        ? page_state.this_page
                        : null,
                  });
                };
              } else {
                var code = node.innerHTML || '';
                var wrapped =
                  'try {\n' +
                  code +
                  "\n} catch(err) {\n  throw new Error(err, { \n    cause: 'customQSLError', \n    page_name: (typeof page_state !== 'undefined' ? page_state.this_page : null) \n  });\n}\n";
                newScript.text = wrapped;
              }
              this.$el[0].appendChild(newScript);
            } else {
              this.$el[0].appendChild(node);
            }
          }
        } catch (err) {
          console.error('Failed to render FreeText widget', err);
          report.logError(err, true);
        }
      },

      destroy: function destroy() {
        FreeText.__super__.destroy.call(this);
      },
    },
    {
      types: ['free-text'],
      views: ['free-text'],
    }
  );

  FreeText.register();

  widgets.FreeText = FreeText;
})((Gryphon.widgets = Gryphon.widgets || {}));
